<template>
  <div id="app">
    <keep-alive include="MusicKnowledgeMusician, MusicKnowledgeInstruments">
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {}
  },
  methods: {},
  created () {
    if (window.location.href.indexOf('from=ppt') >= 0) {
      const query = window.location.search.replace('from=ppt&', '').replace('from=ppt', '')
      const redictUrl = `/#${window.location.pathname}${query}`
      window.location.replace(redictUrl)
    }
  }
}
</script>

<style lang="scss">
a {
  text-decoration: none;
}
div { -webkit-tap-highlight-color:rgba(254, 250, 210, 0.3); }
div:focus, .el-drawer__header span:focus { outline: none; }
body {
  margin: 0;
  padding: 0;
  -webkit-user-select: none;
  font-family: helvetica;
}
.orange-loading {
  .el-loading-spinner {
    i { font-size: 40px; color: #ee9827; }
    p { font-size: 16px; color: #ee9827; margin: 10px 0 0; }
  }
}

.swiper-loading {
  .el-loading-mask {
    background: none;
  }
  .el-loading-spinner {
    i { font-size: 40px; color: #ee9827; }
    p { font-size: 16px; color: #ee9827; margin: 10px 0 0; }
  }
}

.mediaDialog {
  &.el-dialog {
    display: flex;
    flex-direction: column;
    margin:0 !important;
    position:absolute;
    top:50%;
    left:50%;
    transform:translate(-50%,-50%);
  }
  .el-dialog__body { flex:1; overflow: auto; padding: 10px 20px 20px; }
  .el-dialog__close { font-size: 18px; }
}
.video-js .vjs-big-play-button {
  top: 50% !important;
  left: 50% !important;
  margin-left: -1.5em;
  margin-top: -0.75em;
}
.MusicPlayer {
  .aplayer-pic { width: 120px !important; height: 120px !important; }
  .aplayer-body { height: 100% !important; }
  .aplayer-info { height: 100% !important; padding: 10px 10px 0 !important; }
  .aplayer-title { display: block; font-size: 24px !important; }
  .aplayer-author { display: block; font-size: 16px !important; }
  .aplayer-controller { height: 28px !important; }
  .aplayer-bar { height: 4px !important; }
  .aplayer-loaded { height: 4px !important; }
  .aplayer-played { height: 4px !important; }
  .aplayer-thumb {
    width: 20px !important;
    height: 20px !important;
    margin-top: -10px !important;
    margin-right: -20px !important;
  }
  .aplayer-time button { display: none; }
  .aplayer-controller .aplayer-time { font-size: 16px !important; }
}
/* 播放的弹窗 */
.player-dialog {
  background: #000;
  position: relative;
  z-index: 2001;
  .dialogPlayer-close { position: absolute; top: 0; right: 0; z-index: 2100; }
  .el-dialog__header { display: none; }
  .el-dialog__body { width: 100%; height: 100%; box-sizing: border-box; }
}
/* 知识详情页面 - 音乐播放器 */
.musicKnowledge-detail-player {
  height: 100%; background: #fff9e3; border-radius: 15px;
  overflow: hidden;
  .aplayer { background: none; margin: 0; height: 100% !important; position: relative;}
  .aplayer-info { padding: 0 10px !important; overflow: initial !important; display: block !important; width: 100% !important; }
  .aplayer-author { display: none; }
  .aplayer-pic { background: none; position: absolute; left: 10px; width: 40px; height: 40px; bottom: 14px; }
  .aplayer-pause { width: 26px !important; height: 26px !important; border: 2px solid #fff; bottom: 50% !important; right: 50% !important; margin: 0 -15px -15px 0 !important; }
  .aplayer-music {
    width: 100%;
    flex-grow: 0 !important;
    text-align: center; margin: -10px 0 10px !important; padding: 0 !important; line-height: 1em;
    overflow: hidden !important;
    text-overflow:ellipsis !important;
    white-space: nowrap !important;
    .aplayer-title {
      color: #795439;
      line-height: 42px;
      font-size: 20px !important;
      overflow: hidden !important;
      text-overflow: ellipsis !important;
      white-space: nowrap !important;
    }
  }
  .aplayer-body { padding-top: 30px; box-sizing: border-box; height: 100%; }
  .aplayer-icon-pause { position: absolute; top: 3px !important; left: 3px !important; height: 20px !important; width: 20px !important; }
  .aplayer-time {
    position: absolute !important; bottom: -47px; left: 46px; font-size: 14px !important; padding: 0 !important; text-align: center; justify-content: center;
    button { display: none; }
  }
  .aplayer-bar-wrap {
    .aplayer-bar {
      height: 6px; border-radius: 3px;
      .aplayer-loaded { height: 6px; border-radius: 3px; }
      .aplayer-played {
        height: 6px; border-radius: 3px;
        .aplayer-thumb { top: 50%; right: 10px; margin-top: -12px; margin-right: -20px; width: 20px; height: 20px; }
      }
    }
  }
}
/* 音乐律动 - 播放器 */
.rhythm-player {
  .aplayer {
    background: none; box-shadow: none;
    .aplayer-body {
      .aplayer-info { padding: 22px 7px 0 10px; }
    }
  }
  .aplayer-pic {
    background: none;
    .aplayer-button {  button { display: none; } }
    .aplayer-pause, .aplayer-play { width: 60px; height: 60px; border: none; bottom: 50%; right: 50%; margin: 0 -30px -30px 0; }
    .aplayer-play { background: url("~@/assets/images/rhythm-btn-play.png") no-repeat center center; background-size: 100% 100%; }
    .aplayer-pause { background: url("~@/assets/images/rhythm-btn-pause.png") no-repeat center center; background-size: 100% 100%; }
  }
  .aplayer-music { display: none; }
  .aplayer-controller {
    .aplayer-time {
      font-size: 20px; color: #864242;
      .aplayer-volume-wrap { display: none; }
      .aplayer-icon { display: none; }
    }
  }
  .aplayer-bar-wrap {
    .aplayer-bar {
      height: 14px; border-radius: 7px; background: #eee;
      .aplayer-loaded { height: 14px; border-radius: 7px; background: linear-gradient(#e49739, #d59647); }
      .aplayer-played {
        height: 14px; border-radius: 7px; background: linear-gradient(#92e233, #64b407) !important;
        .aplayer-thumb { top: 50%; right: 15px; margin-top: -17px; margin-right: -30px; width: 30px; height: 30px; }
      }
    }
  }
}
/* 音乐知识详情，字号条 */
.music-knowledge-detail-slide {
  .el-slider__runway { background-color: #fffae9; }
  .el-slider__stop { background-color: #feefb6; }
  .el-slider__button { border: 2px solid #ee9827; }
  .el-slider__bar { background-color: #ee9827; }
}
.music-knowledge-search-input {
  .el-input__inner {
    border-right: none;
  }
  .el-input__inner:focus {
    border-color: #ff7e3a !important;
  }
}
/* 音乐律动创建页面，选择水果 */
.rhythm-create-checkbox-group {
  display: flex;
  flex-wrap: wrap;
  width: 756px;
  margin-left: -20px;
}
.rhythm-create-checkbox {
  display: flex;
  flex: 0 0 106px;
  align-items: center;
  justify-content: center;
  margin: 0 0 60px 20px !important;
  height: 66px !important;
  width: 106px;
  padding: 0 0 0 !important;
  box-sizing: border-box;
  position: relative;
  .el-checkbox__label {
    padding-left: 0;
  }
  .el-checkbox__input {
    display: none;
  }
}
.rhythm-create-checkbox-input {
  width: 106px;
  position: absolute;
  left: -1px;
  bottom: -35px;
  input {
    padding: 0 10px;
    text-align: center;
  }
}
/* 音乐律动编辑手势侧边 */
.rhythm-edit-checkbox-group {
  width: 524px;
  margin-left: -20px;
  display: flex;
  flex-wrap: wrap;
}
.rhythm-edit-checkbox {
  display: flex;
  flex: 0 0 106px;
  align-items: center;
  justify-content: center;
  margin: 0 0 60px 20px !important;
  height: 66px !important;
  width: 106px;
  padding: 0 0 0 !important;
  box-sizing: border-box;
  position: relative;
  .el-checkbox__label {
    padding-left: 0;
  }
  .el-checkbox__input {
    display: none;
  }
}
.rhythm-drawer {
  .el-drawer__header {
    margin-bottom: 16px;
  }
  .el-drawer__body {
    height: 0;
  }
}
</style>
